import { Box, BoxProps, styled } from '@mui/material';
import { theme } from '@shared';

type Props = {
  isDragAccept: boolean;
  isDragReject: boolean;
  isDragActive: boolean;
};

const getColor = (props: Props) => {
  if (props.isDragAccept) {
    return theme.palette.green.main;
  }
  if (props.isDragReject) {
    return theme.palette.red.contrastText;
  }
  if (props.isDragActive) {
    return theme.palette.blue.light;
  }
  return ' #0000001f';
};

export const Container = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isDragAccept' && prop !== 'isDragReject' && prop !== 'isDragActive',
})(({ isDragAccept, isDragReject, isDragActive }: BoxProps & Props) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: 2,
  cursor: 'pointer',
  borderStyle: isDragAccept || isDragReject ? 'solid' : 'dashed',
  borderColor: getColor({ isDragAccept, isDragReject, isDragActive }),
  padding: 24,
  marginBottom: 16,
}));
